export interface IPdfWarning
{
	code: string;
	message: string;
}

export const PDF_WARNING_MISSING_PRICING = 'MissingPricing';

const PDF_WARNING_CODE_HEADER = 'X-Pdf-Warning-Code';
const PDF_WARNING_MESSAGE_HEADER = 'X-Pdf-Warning-Message';

const decodeWarningPart = (part: string): string =>
{
	try
	{
		return decodeURIComponent(part);
	}
	catch
	{
		// Malformed percent-encoding - show the raw text rather than failing the download.
		return part;
	}
};

/**
 * Parse the non-fatal PDF warnings the API attaches to a successful proposal PDF response.
 * Both headers are comma-separated and paired by index; each message part is URL-encoded.
 */
export const parsePdfWarningHeaders = (headers: Headers): IPdfWarning[] =>
{
	const codeHeader = headers?.get(PDF_WARNING_CODE_HEADER);
	if (!codeHeader)
	{
		return [];
	}

	const messageParts = (headers.get(PDF_WARNING_MESSAGE_HEADER) ?? '').split(',');

	return codeHeader.split(',')
		.map((code, index) => ({
			code: code.trim(),
			message: decodeWarningPart((messageParts[index] ?? '').trim()),
		}))
		.filter(warning => warning.code);
};
